// extracted by mini-css-extract-plugin
export default {"card":"section-card_card__dG5ux","header":"section-card_header__Hvlcb","title":"section-card_title__IBMSU"};